<template functional>
	<div class="social-icons-wrapper">
		<a
			v-if="props.facebookUrl"
			:class="`social-icon-link icon-${props.iconColor} icon-${props.iconSize}`"
			target="_blank"
			rel="noopener noreferrer"
			title="Share on Facebook"
			aria-label="Share on Facebook"
			:href="props.facebookUrl"
		>
			<i class="fa fa-facebook-square" aria-hidden="true"></i>
		</a>
		<a
			v-if="props.instagramUrl"
			:class="`social-icon-link icon-${props.iconColor} icon-${props.iconSize}`"
			target="_blank"
			rel="noopener noreferrer"
			title="Share on Instagram"
			aria-label="Share on Instagram"
			:href="props.instagramUrl"
		>
			<i class="fa fa-instagram" aria-hidden="true"></i>
		</a>
		<a
			v-if="props.pinterestUrl"
			:class="`social-icon-link icon-${props.iconColor} icon-${props.iconSize}`"
			target="_blank"
			rel="noopener noreferrer"
			title="Share on Pinterest"
			aria-label="Share on Pinterest"
			:href="props.pinterestUrl"
		>
			<i class="fa fa-pinterest" aria-hidden="true"></i>
		</a>
		<a
			v-if="props.mailUrl"
			:class="`icon-link icon-${props.iconColor} icon-${props.iconSize}`"
			target="_blank"
			rel="noopener noreferrer"
			title="Share via Email"
			aria-label="Share via Email"
			:href="props.mailUrl"
		>
			<i class="fa fa-envelope" aria-hidden="true"></i>
		</a>
		<a
			v-if="props.linkedInUrl"
			:class="`social-icon-link icon-${props.iconColor} icon-${props.iconSize}`"
			target="_blank"
			rel="noopener noreferrer"
			title="Share on LinkedIn"
			aria-label="Share on LinkedIn"
			:href="props.linkedInUrl"
		>
			<i class="fa fa-linkedin-square" aria-hidden="true"></i>
		</a>
		<a
			v-if="props.youTubeUrl"
			:class="`social-icon-link icon-${props.iconColor} icon-${props.iconSize}`"
			target="_blank"
			rel="noopener noreferrer"
			title="YouTube Channel"
			aria-label="YouTube Channel"
			:href="props.youTubeUrl"
		>
			<i class="fa fa-youtube-play" aria-hidden="true"></i>
		</a>

		<a
			v-if="props.tikTokUrl"
			:class="`social-icon-link icon-${props.iconColor} icon-${props.iconSize}`"
			target="_blank"
			rel="noopener noreferrer"
			title="TikTok"
			aria-label="TikTok"
			:href="props.tikTokUrl"
		>
			<svg style="height: 0.833em" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" /></svg>
		</a>
	</div>
</template>
<script>
export default {
	name: 'SocialIcons',
	props: {
		pinterestUrl: {
			type: String,
			default: 'https://www.pinterest.com/farmandfleet/'
		},
		iconSize: {
			type: String,
			default: 'sm'
		},
		iconColor: {
			type: String,
			default: 'grey'
		},
		facebookUrl: {
			type: String,
			default: 'https://www.facebook.com/BlainsFarmandFleet'
		},
		instagramUrl: {
			type: String,
			default: 'https://www.instagram.com/blainsfarmandfleet/'
		},
		linkedInUrl: {
			type: String,
			default: 'https://www.linkedin.com/company/blain-supply'
		},
		youTubeUrl: {
			type: String,
			default: 'https://www.youtube.com/user/BlainsFarmAndFleet'
		},
		tikTokUrl: {
			type: String,
			default: "https://www.tiktok.com/@('@')farmandfleet", // @ in URL has to be escaped in pre-rendered razor
		},
		customClass: String
	}
};
</script>
<style lang="less">
@import "../../less/_mixins.less";
.social-icons-wrapper a.social-icon-link {
	display: inline-block;
	margin: 0 0 0 10px;
	&.icon-grey {
		color: #717171;
	}
	&.icon-darkblue {
		color: @DB;
	}
	&.icon-blue {
		color: #346E92;
	}
	&.icon-lightblue {
		color: @LB;
	}
	&.icon-white {
		color: #fff;
	}
	&.icon-sm {
		font-size: 16px;
	}
	&.icon-md {
		font-size: 24px;
	}
	&:first-child {
		margin-left: 0;
	}
	.fa {
		transition: color 0.25s;
		cursor: pointer;
		&:focus {
			outline: none;
		}
	}
	.mobile-styles({
		.social-icon-link:first-child {
			margin: 5px 0 5px 5px;
		}
	});
}
</style>
